import { getFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_MOBILE_BROWSER } from 'reactApp/appHelpers/configHelpers';
import { registerExperiment } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';

const partnersFakedoorValue: 'a' | 'b' = getFeature('partners-fakedoor');

if (!IS_MOBILE_BROWSER) {
    registerExperiment(
        'partners-fakedoor',
        partnersFakedoorValue,
        [
            AnalyticEventNames.QUOTA_LANDING_SHOWN,
            AnalyticEventNames.PARTNERS_FAKEDOOR_VIEW,
            AnalyticEventNames.PARTNERS_FAKEDOOR_MODAL_VIEW,
            AnalyticEventNames.FAST_CHECKOUT_SHOWN,
            AnalyticEventNames.TARIFF_BUY,
        ],
        {
            sendXrayArgs: {
                [AnalyticEventNames.TARIFF_BUY]: ({ paySource }, { eventName }) => ({
                    eventName: paySource?.startsWith('fake_offer') ? 'partners_buy' : eventName,
                }),
                [AnalyticEventNames.FAST_CHECKOUT_SHOWN]: ({ paySource }, { eventName }) => ({
                    eventName: paySource?.startsWith('fake_offer') ? 'partners_checkout' : eventName,
                }),
            },
        }
    );
}

export const isPartnersFakedoor = !IS_MOBILE_BROWSER && partnersFakedoorValue === 'b';
